import React, {
    useEffect,
    useState,
} from 'react'
import { useParams } from 'react-router'
import { database } from '../../components/shared/database'
import OverlayLoader from '../../components/shared/overlay-loader'
import { Link } from 'react-router-dom'

const RecipeDetail = () => {
    const { recipeUid } = useParams()

    const [recipe, setRecipe] = useState()
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        if (recipeUid) {
            setIsLoading(true)

            database('recipes')
                .doc(recipeUid)
                .get()
                .then(snapshot => setRecipe(snapshot.data()))
                .then(() => setIsLoading(false))
        }
    }, [recipeUid])

    if (!recipeUid) {
        return (
            <div>
                Recept nenalezen...
            </div>
        )
    }

    if (isLoading) {
        return <OverlayLoader />
    }

    return (
        <div className="d-flex flex-column container pt-5">
            <div className="d-flex align-items-center justify-content-between w-100">
                <h2>
                    <Link
                        to="/recipes"
                        className="d-flex align-items-center"
                    >
                        <i className="fas fa-angle-double-left mr-2"></i>

                        {recipe?.name}
                    </Link>
                </h2>

                <Link
                    to={`/recipes/${recipeUid}/edit`}
                    className="btn btn-outline-info btn-sm mt-2"
                >
                    <i className="far fa-edit mr-2"/>
                    Upravit
                </Link>
            </div>

            <div className="mt-3">
                {Object.values(recipe?.ingredients || {})
                    ?.map
                    ?.((ingredient, index) => (
                        <div
                            key={index}
                            className="d-flex align-items-center flex-row border-bottom mb-2 pb-2"
                        >
                            <div style={{width: '30%'}}>
                                {ingredient.size}
                            </div>
                            <div>
                                {ingredient.name}
                            </div>
                    </div>
                ))}
            </div>

            <hr />

            {recipe?.procedure}


        </div>
    )
}

export default RecipeDetail
